import { Marker } from 'react-map-gl/mapbox';
import { JobCluster } from './useJobClustering';

type Props = {
  cluster: JobCluster;
  selectedJobs: number[];
  onClusterClick: (cluster: JobCluster) => void;
};

const ClusterMarker = ({ cluster, selectedJobs, onClusterClick }: Props) => {
  if (!cluster.isCluster) {
    return null;
  }

  const hasSelectedJobs = selectedJobs.length > 0 && cluster.jobs.some(job => selectedJobs.includes(job.jobId));

  const color = hasSelectedJobs ? '#FFCABD' : '#ADC6FF';
  const borderColor = hasSelectedJobs ? '#FF5C35' : '#061178';

  const getClusterSize = () => {
    const count = cluster.jobs.length;
    if (count < 10) return 40;
    if (count < 100) return 50;
    return 60;
  };

  const size = getClusterSize();

  return (
    <Marker
      longitude={cluster.longitude}
      latitude={cluster.latitude}
      onClick={(e) => {
        e.originalEvent?.stopPropagation();
        onClusterClick(cluster);
      }}
    >
      <div
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          backgroundColor: color,
          border: `3px solid ${borderColor}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: 'bold',
          color: '#000000',
          boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
          transform: 'translate(-50%, -50%)'
        }}
      >
        {cluster.jobs.length}
      </div>
    </Marker>
  );
};

export default ClusterMarker;